var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#0885d5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.205)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(-0.205)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.409,12.185A1.489,1.489,0,0,1,0,10.63L.328,5.11h.01c0-.013,0-.025,0-.038a.845.845,0,0,1,.01-.1,1.116,1.116,0,0,1,1.059-.952A1.121,1.121,0,0,1,2.481,5.11h0l.333,5.52A1.489,1.489,0,0,1,1.409,12.185Zm0-9.156A1.451,1.451,0,0,1,.037,1.515,1.451,1.451,0,0,1,1.409,0,1.451,1.451,0,0,1,2.782,1.515,1.451,1.451,0,0,1,1.409,3.029Z",
    transform: "translate(9.656 4.981)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoPic);
export default __webpack_public_path__ + "static/media/info-pic.2f3234338ce486cd6b1b23b75a490e82.svg";
export { ForwardRef as ReactComponent };